import { render } from "./Password.vue?vue&type=template&id=1b55bdee"
import script from "./Password.vue?vue&type=script&lang=ts"
export * from "./Password.vue?vue&type=script&lang=ts"
script.render = render

export default script